import getNestedValue from '@/services/functions/getNestedValue'
/**
 * BreadCrumb para componentes genéricos
 */
export default class BreadCrumb {
  /** @type {string?} */ url = '';
  /** @type {string?} */ name = '';
  /** @type {string[]?} */ paths;
  /** @type {string} */ separator = ' ';
  /** @type {string?} */ getter = '';
  /** @type {string?} */ setter = '';
  /** @type {boolean} */ forceDynamic = true;
  /** @type {Function} */ routeCallback = (data, breadcrumb) => ({ path: this.url, name: data });
  /** @type {Function} */ dataCallback = (entity, breadcrumb) => (this.name ? this.name : this.paths?.map(path => getNestedValue(path, entity)).join(this.separator)) || '';
}
